import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { AdminAddDocumentsComponent } from "../admin-add-documents/admin-add-documents.component";
import { AdminEditDocumentComponent } from "../admin-edit-document/admin-edit-document.component";
import { AdminService } from "../admin.service";
import { CommonHelperComponent } from "../../common-helper/common-helper.component";

@Component({
  selector: "app-admin-documents",
  templateUrl: "./admin-documents.component.html",
  styleUrls: ["./admin-documents.component.css"],
})
export class AdminDocumentsComponent implements OnInit {
  documentName: any = "-1";
  matdialogref!: MatDialogRef<AdminAddDocumentsComponent>;
  matDialogref!: MatDialogRef<AdminEditDocumentComponent>;
  searchbutton: boolean = false;
  token: any;
  startPage: any = 1;
  last_page: any = 1;
  DocumentList: any = [];
  SelectedNumber: number = 0;
  docSelectedIds: any = [];
  document_array: any = [];
  fetch_page: any = 0;
  currentPage: any = 0;
  total_cat_count: any;
  perPage: any = 10;
  page: any = 1;
  toggleSearch: boolean = false;
  searchButton: boolean = true;
  loading: boolean = false;
  selectDoc: boolean = true;
  deleteDoc: boolean = false;
  cancelDoc: boolean = false;
  checkBox: boolean = false;
  deleteAction: boolean = false;
  addBtn: boolean = true;
  search_btn: boolean = false;
  clear_Btn: boolean = false;
  isInputValid: boolean = false;
  previousValue: string = "";

  @ViewChild("newItem", { static: false }) inputElement!: ElementRef;
  @ViewChild("newItem") newItem: ElementRef;
  constructor(
    private matdialog: MatDialog,
    public service: AdminService,
    private snackBar: MatSnackBar,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");
    this.GetDocuments(this.documentName);
    let triptype = "documents";
    localStorage.setItem("tripType", triptype);
  }

  onInputChange(value: any) {
    const words = value.toLowerCase().split(" ");
    const capitalizedValue = words
      .map((word: any) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

    const previousLength = this.previousValue.length;
    this.previousValue = capitalizedValue;

    if (
      capitalizedValue.length < previousLength ||
      (capitalizedValue.length > previousLength && this.clear_Btn)
    ) {
      this.documentName = "";
      this.GetDocuments(this.documentName);
      this.fetch_page = 0;
      this.search_btn = true;
      this.clear_Btn = false;
    }

    if (capitalizedValue.length >= 1) {
      this.isInputValid = true;
    } else {
      this.resetSearch();
    }
  }

  public GetDocuments(type: any) {
    this.documentName = type;
    this.loading = true;
    this.service
      .GetDocuments(this.token, this.documentName, this.perPage, this.startPage)
      .subscribe(
        (response: any) => {
          if (response.status === 200) {
            this.loading = false;
            this.DocumentList = response.body.data.data;
            this.document_array.push(response.body.meta);
            this.last_page = response.body.data.meta.lastPage;
          }
        },
        (error) => {
          this.DocumentList = [];
          this.loading = false;
          if (error.status == 404) {
            return;
          }
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }

  GoToDocument(event: any, item: any) {
    this.matdialogref = this.matdialog.open(AdminAddDocumentsComponent, {
      width: "40vw",
      data: event == "Edit" ? item : null,
    });
    this.matdialogref.afterClosed().subscribe((result: any) => {
      if (result.event === "Success") {
        this.GetDocuments(this.documentName);
      }
    });
  }

  public onSelect() {
    this.selectDoc = false;
    this.cancelDoc = true;
    this.deleteDoc = true;
    this.checkBox = true;
    this.deleteAction = true;
    this.addBtn = false;
    this.searchButton = false;
  }

  public matItem(event: any, item: any, index: number) {
    if (event.checked) {
      this.docSelectedIds.push(item);
      this.SelectedNumber += 1;
    } else {
      this.docSelectedIds.splice(index, 1);
      this.SelectedNumber -= 1;
    }
  }
  public onSelectCancel() {
    this.docSelectedIds = [];
    this.SelectedNumber = 0;
    this.cancelDoc = false;
    this.selectDoc = true;
    this.deleteDoc = false;
    this.checkBox = false;
    this.toggleSearch = false;
    this.searchButton = true;
    this.deleteAction = false;
    this.addBtn = true;
    this.GetDocuments(this.documentName);
  }

  public onDelete() {
    if (this.SelectedNumber <= 0) {
      this.snackBar.open("Please select Documents to delete", "Fail", {
        duration: 5000,
      });
      return;
    } else {
      const dialogRef = this.matdialog.open(CommonHelperComponent, {
        data: { message: "Are you sure you want to delete this record?" },
      });
      dialogRef.afterClosed().subscribe((res) => {
        if (res == "yes") {
          const deleteData = {
            ids: this.docSelectedIds,
          };
          this.service.DeleteDocuments(deleteData, this.token).subscribe(
            (response: any) => {
              if (response.status === 200 || response.status === 201) {
                this.onSelectCancel();
                this.snackBar.open("Document deleted successfully", "Success", {
                  duration: 5000,
                });
                this.GetDocuments(this.documentName);
              }
            },
            (error) => {
              if (error.error.message === "jwt malformed") {
                this.router.navigateByUrl("admin/login");
                window.localStorage.clear();
              }
              if (error.error.message === "jwt expired") {
                this.router.navigateByUrl("admin/login");
                window.localStorage.clear();
              }
              if (error.error.message === "invalid signature") {
                this.router.navigateByUrl("admin/login");
                window.localStorage.clear();
              }
              this.snackBar.open(error.error.message, "Fail", {
                duration: 5000,
              });
            }
          );
        }
      });
    }
  }

  openSearch() {
    this.search_btn = true;
    this.clear_Btn = false;
    this.toggleSearch = true;
    this.searchButton = false;
    this.addBtn = false;
    this.cancelDoc = true;
    this.deleteDoc = true;
    this.selectDoc = false;
    this.checkBox = true;
    this.deleteAction = true;
    if (this.toggleSearch) {
      setTimeout(() => this.inputElement.nativeElement.focus(), 0);
    }
  }

  search(value: any) {
    const words = value.toLowerCase().split(" ");
    const capitalizedValue = words
      .map((word: any) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
    if (value != "") {
      this.clear_Btn = true;
      this.searchButton = false;
      this.toggleSearch = true;
      this.search_btn = false;
      this.GetDocuments(capitalizedValue);
    }
  }

  resetSearch() {
    this.newItem.nativeElement.value = "";
    this.documentName = "";
    this.GetDocuments(this.documentName);
    this.searchButton = true;
    this.toggleSearch = false;
    this.addBtn = true;
    this.selectDoc = true;
    this.cancelDoc = false;
    this.deleteDoc = false;
    this.deleteAction = false;
    this.checkBox = false;
  }
}
